module.exports={
    "easy": {
        "info": {
            "level": "Low",
            "traffic": "Low",
            "duration":1800
        },

        "initparams": {
            "showAttackAircraftVisibility": false,
            "hideScore": true
        },

        "updateSchema":[
            {   
                "timestamp": 0,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.1,
                    "nonResponsiveProbability": 0.2
                },
                "trafficSettings": {
                    "windDirection": 60,
                    "windSpeed": 2,
                    "arrival": 1,
                    "departure": 1,
                    "overflight": 1
                },
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {   
                "timestamp": 600,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.1,
                    "nonResponsiveProbability": 0.2
                },
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {   
                "timestamp":1200,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.2,
                    "impersonateProbability": 0.3,
                    "falseInformationProbability": 0.1
                },
                "injection": ["IMPERSONATED_AIRCRAFT"]
            }
        ]
    },
    "normal": {
        "info": {
            "level": "Normal",
            "traffic": "Normal",
            "duration": 1800
        },
        "initparams": {
            "showAttackAircraftVisibility": false,
            "hideScore": true
        },

        "updateSchema":[
            {   
                "timestamp": 0,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.3,
                    "nonResponsiveProbability": 0.2,
                    "transponderCodeAlterProbability": 0.6
                },
                "trafficSettings": {
                    "windDirection": 60,
                    "windSpeed": 8,
                    "arrival": 2,
                    "departure": 2,
                    "overflight": 2
                },
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {   
                "timestamp": 600,
                "attackSettings": {
                    
                    "nonResponsiveProbability": 0.2
                },
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {   
                "timestamp":1200,
                "attackSettings": {
                    "impersonateProbability": 0.2,
                    "nonResponsiveProbability": 0.3,
                    "falseInformationProbability": 0.1
                }
            }
        ]
    },
    "hard": {
        "info": {
            "level": "High",
            "traffic": "High",
            "duration": 1800
        },
        "initparams": {
            "showAttackAircraftVisibility": false,
            "hideScore": true
        },

        "updateSchema":[
            {   
                "timestamp": 0,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.6,
                    "nonResponsiveProbability": 0.1,
                    "falseInformationProbability": 0.15,
                    "impersonateProbability": 0.1,
                    "transponderCodeAlterProbability": 0.15,
                    "duplicateProbability": 0.15,
                    "nonMovingProbability": 0.15,
                    "virtualTrajectoryAlterProbability": 0.1,
                    "positionAlterProbability": 0.1
                },
                "trafficSettings": {
                    "windDirection": 60,
                    "windSpeed": 20,
                    "arrival": 4,
                    "departure": 4,
                    "overflight": 4
                },
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {   
                "timestamp": 600,
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {
                "timestamp": 896,
                "floodingOfNonResponsive": 5
            },
            {
                "timestamp": 919,
                "floodingOfNonResponsive": 0
            },
            {   
                "timestamp":1200,
                "injection": ["FALSE_SQUAWK", "IMPERSONATED_AIRCRAFT", "FALSE_INFORMATION"]
            }
        ]
    },
    "baseline1": {
        "info": {
            "level": "N.A.",
            "traffic": "Low",
            "duration": 1800
        },
        "initparams": {
            "hideScore": true
        },
        "updateSchema": [
            {
                "timestamp": 0,
                "trafficSettings": {
                    "windDirection": 60,
                    "windSpeed": 2,
                    "arrival": 1,
                    "departure": 1,
                    "overflight": 1
                }
            }
        ]
    },
    "baseline2": {
        "info": {
            "level": "N.A.",
            "traffic": "Normal",
            "duration": 1800
        },
        "initparams": {
            "hideScore": true
        },
        "updateSchema": [
            {
                "timestamp": 0,
                "trafficSettings": {
                    "windDirection": 60,
                    "windSpeed": 2,
                    "arrival": 2,
                    "departure": 2,
                    "overflight": 2
                }
            }
        ]
    },
    "baseline3": {
        "info": {
            "level": "N.A.",
            "traffic": "High",
            "duration": 1800
        },
        "initparams": {
            "hideScore": true
        },
        "updateSchema": [
            {
                "timestamp": 0,
                "trafficSettings": {
                    "windDirection": 60,
                    "windSpeed": 2,
                    "arrival": 4,
                    "departure": 4,
                    "overflight": 4
                }
            }
        ]
    },
    "speed_devonly": {
        "info": {
            "level": "Normal",
            "traffic": "Normal",
            "duration": 90
        },
        "initparams": {
            "showAttackAircraftVisibility": true
        },
        "updateSchema": [
            {   
                "timestamp": 5,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.1,
                    "nonResponsiveProbability": 0.2
                },
                "trafficSettings": {
                    "windDirection": 120,
                    "windSpeed": 10,
                    "arrival": 7,
                    "departure": 3,
                    "overflight": 2
                },
                "directInjection": ["NON_RESPONSIVE"],
                "injection": ["FALSE_INFORMATION"]
            },
            {   
                "timestamp": 10,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.2,
                    "nonResponsiveProbability": 0.3,
                    "falseInformationProbability": 0.1
                },
                "trafficSettings": {
                    "windDirection": 100,
                    "windSpeed": 3,
                    "arrival": 10,
                    "departure": 10,
                    "overflight": 1
                }
            },
            {   
                "timestamp": 15,
                "attackSettings": {
                    "nonMovingProbability": 0.2
                },
                "trafficSettings": {
                    "windDirection": 99,
                    "windSpeed": 2,
                    "arrival": 3,
                    "departure": 4,
                    "overflight": 1
                }
            },
            {   
                "timestamp": 20,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.4,
                    "duplicateProbability": 0.4
                },
                "injection": ["IMPERSONATED_AIRCRAFT"]
            },
            {   
                "timestamp": 25,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.3,
                    "duplicateProbability": 0.4
                }
            },
            {   
                "timestamp": 30,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.2
                }
            },
            {   
                "timestamp": 35,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.3
                },
                "directInjection": ["NON_RESPONSIVE"]
            },
            {   
                "timestamp": 40,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.4
                },
                "injection": ["FALSE_SQUAWK"]
            },
            {   
                "timestamp": 45,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.1,
                    "transponderCodeAlterProbability": 0.2
                }
            },
            {   
                "timestamp": 50,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.2
                }
            },
            {   
                "timestamp": 55,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.3
                }
            },
            {   
                "timestamp": 60,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.4
                }
            },
            {   
                "timestamp": 65,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.1,
                    "nonMovingProbability": 0.3,
                    "transponderCodeAlterProbability": 0
                }
            },
            {   
                "timestamp": 70,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.2
                }
            },
            {   
                "timestamp": 75,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.3
                }
            },
            {   
                "timestamp": 80,
                "attackSettings": {
                    "probabilityOfNewAircraft": 0.4
                }
            }
        ]
    },
    "long_devonly": {
        "info": {
            "level": "Normal",
            "traffic": "Normal",
            "duration": 90000
        },
        "initparams": {
            "showAttackAircraftVisibility": true
        },
        "updateSchema": [
            {   
                "timestamp": 5,
                "trafficSettings": {
                    "windDirection": 120,
                    "windSpeed": 10,
                    "arrival": 5,
                    "departure": 1
                }
            }
        ]
    }
}